// Vendor Libs
import React, {Component} from 'react';
import PropTypes from 'prop-types';

// Components
import FormButtons from '../core/form-buttons';
import Input from '../core/input';
import Permissions from '../core/permissions';
import SearchPagination from '../app/search-pagination';
import SearchTableWithSort from '../app/search-tablewithsort';
import ServicesExportPanelAction from '../app/services-export-panel-action';
import ServicesSearchForm from '../app/services-search-form';
import ServicesSearchPanelAction from '../app/services-search-panel-action';

// Containers
import withSearch from '../../containers/with-search';

const servicesDataKey = 'roles';

class Roles extends Component {
    getColumnConfig() {
        return [
            {
                dataKey: 'name',
                link: '/roles',
                linkKey: 'roleId',
                title: 'Name',
                type: 'link',
                width: '100%',
            },
        ];
    }

    getPaginationProps() {
        const {query, totalPages} = this.props;

        return {
            maxPages: 9,
            query,
            totalPages,
        };
    }

    getTablewithsortProps() {
        return {
            ...this.props,
            ...{
                activeRowKey: 'roleId',
                activeRowValueKey: 'routerParams.roleId',
                columnConfig: this.getColumnConfig(),
                rowDetails: {
                    whitelistKeys: ['roleId', 'childRoles'],
                },
                servicesDataKey,
            },
        };
    }

    renderForm = () => (
        <ServicesSearchForm formName={servicesDataKey} servicesDataKey={servicesDataKey}>
            <Input label="Name" name="name" title="Use wildcard (*) for partial name match" />
            <FormButtons />
        </ServicesSearchForm>
    );

    render() {
        const {searchData} = this.props;

        return (
            <Permissions adminOnly={true} notAuthorizedMessage={true}>
                <div className="roles">
                    <ServicesExportPanelAction searchData={searchData} />
                    <ServicesSearchPanelAction contentRenderer={this.renderForm} />
                    <SearchPagination {...this.getPaginationProps()} />
                    <SearchTableWithSort {...this.getTablewithsortProps()} />
                </div>
            </Permissions>
        );
    }
}

Roles.propTypes = {
    query: PropTypes.object,
    searchData: PropTypes.array,
    totalPages: PropTypes.number,
};

export default withSearch(Roles, servicesDataKey);
